export default __webpack_public_path__ + "static/media/i3-group-photo.58356dc7.jpg";